import React from 'react';
import './anaf.css'
import rmfp from './rmfp.png'
import anafLogo from './icon_ANAF.jpg'

export default () => {
    return (
        <div className="anafFooter">
            <img src={rmfp}  className="rmpf"/>
            <h5 className="titleAnaf">GUVERNUL ROMANIEI
            MINISTERUL FINANTELOR PUBLICE
            </h5>
            <p className="paragrafAnaf">
                Daca nu primiti bonul fiscal, aveti obligatia sa-l solicitati. <span className="paragrafAnafRed">In cazul unui refuz, aveti dreptul de a beneficia de bunul achizitionat sau de serviciul prestat fara plata contravalorii acestuia. Solicitati si pastrati bonurile fiscale pentru a putea participa la extragerile lunare si ocazionale ale loteriei bonurilor fiscale.</span>
            </p>
            <p className="paragrafAnaf">
                Este interzisa inmanarea catre client a altui document care atesta plata contravalorii bunurilor sau serviciilor prestate decat bonul fiscal. Pentru a semnala nerespectarea obligatiilor legale ale operatorilor economici, puteti apela <span className="paragrafAnafRed">gratuit, non-stop, serviciul TelVerde al Ministerului Finantelor Publice: 0800.800.085.</span>
            </p>
            <img src={anafLogo} className="anafLogo"/>
            <p className="paragrafAnaf">
                Aceste drepturi si obligatii sunt stabilite prin prevederile Ordonantei de Urgenta a Guvernului cu nr. 28/1999 privind obligatia operatorilor economici de a utiliza aparate de marcat electronice fiscale.
            </p>
        </div>
    )
}

